'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
export const useHotDeals = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v1/allows/affiliate/hot-deals"](),
      select: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useSuspenseQuery(t0);
};
export type HotDeal = ReturnType<typeof useHotDeals>['data'][number];
function _temp(t0) {
  const {
    affiliateHotDealId,
    merchantCode,
    ...hotDeal
  } = t0;
  return affiliateHotDealId && merchantCode ? [{
    ...hotDeal,
    affiliateHotDealId,
    merchantCode
  }] : [];
}
function _temp2(response) {
  return (response.context?.contents ?? []).flatMap(_temp);
}